import api from "../../services/api";

const useAppointments = () => {
  const list = async (params) => {
    const { data } = await api.request({
      url: "/appointments",
      method: "GET",
      params,
    });
    return data;
  };

  const save = async (data) => {
    const { data: responseData } = await api.request({
      url: "/appointments",
      method: "POST",
      data,
    });
    return responseData;
  };

  const update = async (data) => {
    const { data: responseData } = await api.request({
      url: `/appointments/${data.id}`,
      method: "PUT",
      data,
    });
    return responseData;
  };

  const remove = async (id) => {
    const { data } = await api.request({
      url: `/appointments/${id}`,
      method: "DELETE",
    });
    return data;
  };

  return { list, save, update, remove };
};

export default useAppointments;
